import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../api/client'
import { SUBSCRIPTION_ACTIVATED_EVENT } from '../utils/permissionDeniedEvents'

export default function SubscriptionUpgradeBanner() {
  const navigate = useNavigate()
  const [warningItem, setWarningItem] = useState(null)
  const [dismissed, setDismissed] = useState(false)

  const checkStatus = async () => {
    try {
      const res = await api.get('/api/subscriptions/status')
      const subs = res.data?.subscriptions || []
      // Check for trialing subscriptions expiring within 3 days
      const expiringTrial = subs.find(
        (s) => s.status === 'TRIALING' && s.days_remaining !== null && s.days_remaining <= 3
      )
      if (expiringTrial) {
        setWarningItem({
          name: expiringTrial.item_name,
          daysRemaining: expiringTrial.days_remaining,
        })
      } else {
        setWarningItem(null)
      }
    } catch {
      // Non-blocking background check
    }
  }

  useEffect(() => {
    checkStatus()

    const onActivated = () => {
      checkStatus()
    }
    window.addEventListener(SUBSCRIPTION_ACTIVATED_EVENT, onActivated)
    return () => window.removeEventListener(SUBSCRIPTION_ACTIVATED_EVENT, onActivated)
  }, [])

  if (!warningItem || dismissed) return null

  return (
    <aside
      aria-label="Subscription status"
      className="bg-gradient-to-r from-amber-500 via-amber-600 to-orange-500 text-white px-4 py-2.5 text-xs sm:text-sm font-medium shadow-sm flex items-center justify-between gap-3 animate-fade-in"
    >
      <div className="flex items-center gap-2">
        <span className="material-symbols-outlined text-base shrink-0">warning</span>
        <span>
          Your free trial of <strong className="font-bold underline">{warningItem.name}</strong> expires in{' '}
          <strong className="font-bold">
            {warningItem.daysRemaining} {warningItem.daysRemaining === 1 ? 'day' : 'days'}
          </strong>
          . Upgrade or manage your workspace entitlements to ensure uninterrupted access.
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={() => navigate('/masters/subscriptions')}
          className="bg-white text-amber-900 hover:bg-amber-50 font-bold px-3 py-1 rounded-lg text-xs transition shadow-xs cursor-pointer"
        >
          Manage Subscriptions
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-white/80 hover:text-white p-1 rounded-md transition cursor-pointer"
          title="Dismiss warning"
          aria-label="Dismiss warning"
        >
          <span className="material-symbols-outlined text-base">close</span>
        </button>
      </div>
    </aside>
  )
}
